import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import { RiDoubleQuotesL } from "react-icons/ri";

const testimonialData = [
  {
    id: 1,
    img: "/assets/images/user/user-thumb-01.png",
    name: "John Wlick",
    designation: "Ceo",
    brandImg: "/assets/images/brand/brand-thumb-01.png",
    description:
      "More-or-less normal distribution of letters, as opposed to using content making it look like readable english.",
    rating: 4.5,
  },
  {
    id: 2,
    img: "/assets/images/user/user-thumb-02.png",
    name: "Joshua Sendu",
    designation: "Engineer",
    brandImg: "/assets/images/brand/brand-thumb-01.png",
    description:
      "More-or-less normal distribution of letters, as opposed to using content making it look like readable english.",
    rating: 4.5,
  },
  {
    id: 3,
    img: "/assets/images/user/user-thumb-03.png",
    name: "Penelopa Miller",
    designation: "Team Manager",
    brandImg: "/assets/images/brand/brand-thumb-01.png",
    description:
      "More-or-less normal distribution of letters, as opposed to using content making it look like readable english.",
    rating: 4.5,
  },

  {
    id: 4,
    img: "/assets/images/user/user-thumb-02.png",
    name: "Joshua Sendu",
    designation: "Engineer",
    brandImg: "/assets/images/brand/brand-thumb-01.png",
    description:
      "More-or-less normal distribution of letters, as opposed to using content making it look like readable english.",
    rating: 4.5,
  },
];

const Testimonial = () => {
  return (
    <section className="rs-testimonial-area section-space rs-testimonial-one primary-bg rs-swiper">
      <div className="container">
        <div className="row g-5 section-title-space align-items-center">
          <div className="col-xl-7 col-lg-7">
            <div className="rs-section-title-wrapper">
              <span className="rs-section-subtitle has-theme-orange justify-content-start">
                <FaPlay color="#EA5501" size={12} />
                Testimonials
              </span>
              <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                What people say about Industrie company
              </h2>
            </div>
          </div>
          <div className="col-xl-5 col-lg-5">
            <div className="rs-testimonial-btn">
              <Link
                className="rs-btn has-theme-orange has-icon has-bg"
                to="/contact"
              >
                More Reviews
                <span className="icon-box">
                  <FiArrowRight className="icon-first" />
                  <FiArrowRight className="icon-second" />
                </span>
              </Link>
            </div>
          </div>
        </div>

        {/* Swiper */}
        <div className="row">
          <div className="col-12">
            <Swiper
              modules={[Autoplay, Pagination]}
              slidesPerView={3}
              spaceBetween={30}
              loop={true}
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
            >
              {testimonialData.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="rs-testimonial-item has-clip-path">
                    <div className="rs-testimonial-content">
                      <div className="rs-testimonial-top">
                        <div className="rs-testimonial-avater-wrapper">
                          <div className="rs-testimonial-avater-thumb">
                            <img src={item.img} alt={item.name} />
                          </div>
                          <div className="rs-testimonial-avater-info">
                            <h6 className="rs-testimonial-avater-title">
                              {item.name}
                            </h6>
                            <span className="rs-testimonial-avater-designation">
                              {item.designation}
                            </span>
                          </div>
                        </div>
                        <div className="rs-testimonial-icon">
                          <img src={item.brandImg} alt="brand" />
                        </div>
                      </div>
                      <div className="rs-testimonial-description">
                        <p>{item.description}</p>
                      </div>
                      <div className="rs-testimonial-rating-wrapper">
                        <div className="rs-rating">
                          {[...Array(5)].map((_, i) => (
                            <span key={i}>
                              <i
                                className={
                                  i < Math.floor(item.rating)
                                    ? "ri-star-fill"
                                    : i < item.rating
                                      ? "ri-star-half-line"
                                      : "ri-star-line"
                                }
                              ></i>
                            </span>
                          ))}
                        </div>
                        <div className="rs-testimonial-quote">
                          <RiDoubleQuotesL />
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
